"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = presetFacebookServerSidePixelConfig;
var _renderTemplate = _interopRequireDefault(require("./renderTemplate"));
var _uuid = require("uuid");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _facebookSnippet = _interopRequireDefault(require("./facebookSnippet"));
var _md = _interopRequireDefault(require("md5"));
var initializedPixels = {};
var FACEBOOK_STANDARD_EVENTS = ['AddPaymentInfo', 'AddToCart', 'AddToWishlist', 'CompleteRegistration', 'Contact', 'CustomizeProduct', 'Donate', 'FindLocation', 'InitiateCheckout', 'Lead', 'PageView', 'Purchase', 'Schedule', 'Search', 'StartTrial', 'SubmitApplication', 'Subscribe', 'ViewContent'];
var externalId;

/**
 * The external id is a hash sent to Facebook from the browser pixel and from the the server-side, used for
 * deduplication of events. The value is an sha256 hex hash of EA's user id. or a random uuid if EA's user id isn't
 * availble for some reason.
 * @returns {string|*}
 */
function getExternalId() {
  if (externalId) {
    return externalId;
  }
  if (!window.EkoAnalytics || !window.EkoAnalytics('getUid')) {
    externalId = (0, _uuid.v4)();
  } else {
    externalId = (0, _md["default"])(window.EkoAnalytics('getUid'));
  }
  return externalId;
}
function presetFacebookServerSidePixelConfig(pixelConfig, extendedContext) {
  var newPixelConfig = Object.assign({}, pixelConfig);
  if (!/^facebook$/i.test(newPixelConfig.platform) || !newPixelConfig.serverside) {
    return newPixelConfig;
  }

  // We override the existing html template provided in contentful
  newPixelConfig.htmlTemplate = '';

  // Add the init snippet if this is the first time we fire this facebook pixel
  if (!initializedPixels[pixelConfig.facebookPixelId]) {
    newPixelConfig.htmlTemplate = (0, _facebookSnippet["default"])(newPixelConfig.facebookPixelId, getExternalId());
    initializedPixels[newPixelConfig.facebookPixelId] = true;
  }
  var renderedCustomData = '{}';
  if (newPixelConfig.facebookCustomData) {
    renderedCustomData = (0, _renderTemplate["default"])(JSON.stringify(newPixelConfig.facebookCustomData), extendedContext);
  }
  newPixelConfig.facebookpixel = {
    pixelid: newPixelConfig.facebookPixelId,
    eventid: (0, _uuid.v4)(),
    eventname: newPixelConfig.facebookEventName,
    customdata: JSON.parse(renderedCustomData),
    externalid: getExternalId(),
    fbc: _jsCookie["default"].get('_fbc') || '',
    fbp: _jsCookie["default"].get('_fbp') || ''
  };

  // We override the html template so we can tag the pixel with a generated event id which will be used
  // for deduplication
  // eslint-disable-next-line max-len
  var trackEventType = FACEBOOK_STANDARD_EVENTS.includes(newPixelConfig.facebookpixel.eventname) ? 'trackSingle' : 'trackSingleCustom';
  // eslint-disable-next-line max-len
  newPixelConfig.htmlTemplate += " <script> fbq('".concat(trackEventType, "', '").concat(newPixelConfig.facebookpixel.pixelid, "', '").concat(newPixelConfig.facebookpixel.eventname, "', ").concat(renderedCustomData, ", {'eventID': '").concat(newPixelConfig.facebookpixel.eventid, "'}) </script> ");
  return newPixelConfig;
}